<template>
  <div class="about-page">
    <section class="hero">
      <div class="hero-image-wrap">
        <img class="hero-image" :src="officeImage" :alt="texts.hero.alt" />
      </div>
      <div class="container hero-content">
        <div class="hero-copy">
          <p class="eyebrow">BAILYHANGA / About Us</p>
          <h1>{{ texts.hero.title }}</h1>
          <p class="lead">{{ texts.hero.desc }}</p>
          <a class="hero-link" href="#company">{{ texts.companyTitle }}<span aria-hidden="true">&darr;</span></a>
        </div>
      </div>
    </section>

    <main>
      <section id="company" class="company-section">
        <div class="container company-grid">
          <div class="section-marker">
            <span>01</span>
            <p>{{ texts.companyTitle }}</p>
          </div>
          <div class="company-story">
            <h2>{{ texts.companyTitle }}</h2>
            <p>{{ texts.companyDesc1 }}</p>
            <p>{{ texts.companyDesc2 }}</p>
          </div>
        </div>
        <div class="container stats-row">
          <div v-for="item in texts.stats" :key="item.label" class="stat-item">
            <div>
              <strong>{{ item.value }}</strong>
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="solutions-section">
        <div class="container">
          <div class="section-intro">
            <div class="section-marker light">
              <span>02</span>
              <p>{{ texts.productTitle }}</p>
            </div>
            <div>
              <h2>{{ texts.productTitle }}</h2>
              <p>{{ texts.productDesc }}</p>
            </div>
          </div>
          <div class="product-grid">
            <article v-for="(item, index) in texts.products" :key="item.title" class="product-item">
              <div class="product-number">0{{ index + 1 }}</div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
              <a :href="item.href">{{ item.link }}<span aria-hidden="true">&rarr;</span></a>
            </article>
          </div>
        </div>
      </section>

      <section class="values-section">
        <div class="container values-layout">
          <div class="values-title">
            <div class="section-marker">
              <span>03</span>
              <p>{{ texts.valueTitle }}</p>
            </div>
            <h2>{{ texts.valueTitle }}</h2>
          </div>
          <div class="values-list">
            <article v-for="(item, index) in texts.values" :key="item.title" class="value-item">
              <span class="value-index">0{{ index + 1 }}</span>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </article>
          </div>
        </div>
      </section>

      <section class="contact-section">
        <div class="container contact-grid">
          <div>
            <p class="contact-kicker">04 / {{ texts.contactTitle }}</p>
            <h2>{{ texts.contactTitle }}</h2>
          </div>
          <div class="contact-details">
            <p>{{ texts.contactAddress }}</p>
            <p>{{ texts.contactPhone }}</p>
            <a href="mailto:it_jch@xinhe.space">{{ texts.contactEmail }}</a>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { localeState } from "@/utils/locale";
import officeImage from "@/assets/01271e5de85b9ca8012138534e001d.jpg";

export default {
  name: "AboutUsPage",
  data() {
    return {
      officeImage,
      copy: {
        zh: {
          hero: {
            title: "做跨境用XINHE TRADING (HONGKONG) LIMITED",
            desc: "以一站式跨境电商运营管理系统，助力卖家轻松实现业务增长。",
            alt: "XINHE TRADING (HONGKONG) LIMITED办公室",
          },
          companyTitle: "关于XINHE TRADING (HONGKONG) LIMITED",
          companyDesc1: "公司创立于 2017 年，专注为跨境电商卖家提供精细化运营和业财一体化解决方案，让跨境电商经营更简单。",
          companyDesc2: "我们围绕订单、库存、财务、广告、品牌分析和组织协作等场景，帮助团队构建更高效的日常管理体系。",
          stats: [
            { value: "TOP 1", label: "行业市占率领先" },
            { value: "500000+", label: "跨境企业的共同选择" },
            { value: "20+", label: "服务中心" },
            { value: "100+", label: "服务上市 / IPO 阶段企业" },
          ],
          productTitle: "产品介绍",
          productDesc: "为跨境电商企业提供供应链、运营、广告和数据分析的一体化解决方案。",
          products: [
            { title: "业财一体化管理", desc: "洞察业务数据变化，支持利润、订单和经营结果的一体化分析。", href: "/#/product/detail", link: "查看产品" },
            { title: "高效管理亚马逊广告", desc: "统一管理广告投放策略、预算和效果分析，提升广告回报。", href: "/#/ad/detail", link: "查看广告方案" },
            { title: "品牌与运营协同", desc: "通过品牌分析、经营报表和合规流程支持团队长期增长。", href: "/#/brand-analytics/detail", link: "查看品牌分析" },
          ],
          valueTitle: "价值观与愿景",
          values: [
            { title: "价值观", desc: "客户第一，简单、极致、创新。" },
            { title: "愿景", desc: "成为值得长期信赖的跨境 SaaS 服务伙伴。" },
            { title: "使命", desc: "让跨境电商经营更简单、更高效、更可持续。" },
          ],
          contactTitle: "联系我们",
          contactAddress: "香港总部：RM D38, 11/F, MAI TAK IND. BLDG., 221 WAI YIP ST.,",
          contactPhone: "电话：+86  15262358284",
          contactEmail: "邮箱：it_jch@xinhe.space",
        },
        en: {
          hero: {
            title: "Choose Hunan Panxian for Cross-Border Growth",
            desc: "Use a one-stop cross-border e-commerce operating system to help seller teams grow with less friction.",
            alt: "Hunan Panxian office",
          },
          companyTitle: "About XINHE TRADING (HONGKONG) LIMITED",
          companyDesc1: "Founded in 2017, we focus on refined operations and integrated finance-operations solutions for cross-border e-commerce sellers, making daily management simpler.",
          companyDesc2: "Across orders, inventory, finance, advertising, brand analytics, and organizational collaboration, we help teams build a more efficient operating system.",
          stats: [
            { value: "TOP 1", label: "Leading market presence" },
            { value: "500000+", label: "A common choice for cross-border businesses" },
            { value: "20+", label: "Service centers" },
            { value: "100+", label: "Public / IPO-stage clients served" },
          ],
          productTitle: "Our Solutions",
          productDesc: "Integrated solutions for supply chain operations, finance, advertising, and data-driven management for cross-border e-commerce teams.",
          products: [
            { title: "Integrated Finance and Operations", desc: "Analyze profit, orders, and business performance in one management layer.", href: "/#/product/detail", link: "View product" },
            { title: "Efficient Amazon Advertising", desc: "Centralize advertising strategy, budget control, and performance analysis.", href: "/#/ad/detail", link: "View advertising" },
            { title: "Brand and Operations Collaboration", desc: "Support long-term growth with brand analytics, reporting, and compliance workflows.", href: "/#/brand-analytics/detail", link: "View brand analytics" },
          ],
          valueTitle: "Values and Vision",
          values: [
            { title: "Values", desc: "Customer first, simplicity, excellence, and innovation." },
            { title: "Vision", desc: "Become a long-term trusted SaaS partner for cross-border commerce." },
            { title: "Mission", desc: "Make cross-border e-commerce operations simpler, faster, and more sustainable." },
          ],
          contactTitle: "Contact Us",
          contactAddress: "Changsha Headquarters: 17F, Building A-1, Media Art Park, 601 Dongfanghong North Road, High-tech Zone, Changsha",
          contactPhone: "Phone: +86  15262358284",
          contactEmail: "Email: it_jch@xinhe.space",
        },
      },
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale] || this.copy.zh;
    },
  },
};
</script>

<style scoped>
.about-page {
  --ink: #122620;
  --paper: #f5f2e9;
  --accent: #d8944b;
  --line: rgba(18, 38, 32, 0.16);
  background: var(--paper);
  color: var(--ink);
  min-height: 100%;
}
.hero {
  background: #e9e5da;
  min-height: 630px;
  overflow: hidden;
  position: relative;
}
.container {
  margin: 0 auto;
  max-width: 80rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.hero-image-wrap {
  height: 360px;
  overflow: hidden;
  position: relative;
}
.hero-image-wrap::after {
  background: linear-gradient(180deg, transparent 55%, #e9e5da 100%);
  content: "";
  inset: 0;
  position: absolute;
}
.hero-image {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
.hero-content {
  position: relative;
  z-index: 1;
}
.hero-copy {
  padding: 1.5rem 0 4rem;
}
.eyebrow,
.contact-kicker {
  color: #9a622c;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  margin: 0 0 1.35rem;
  text-transform: uppercase;
}
h1 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2.65rem;
  font-weight: 400;
  line-height: 1.08;
  margin: 0;
  max-width: 740px;
}
.lead {
  color: rgba(18, 38, 32, 0.68);
  font-size: 1rem;
  line-height: 1.8;
  margin: 1.35rem 0 0;
  max-width: 34rem;
}
.hero-link {
  align-items: center;
  border-bottom: 1px solid var(--ink);
  color: var(--ink);
  display: inline-flex;
  font-size: 0.82rem;
  gap: 2rem;
  margin-top: 2rem;
  padding-bottom: 0.45rem;
  text-decoration: none;
}
.company-section {
  padding: 5rem 0 0;
}
.company-grid,
.section-intro,
.values-layout,
.contact-grid {
  display: grid;
  gap: 2rem;
}
.section-marker {
  align-items: flex-start;
  display: flex;
  gap: 1rem;
}
.section-marker span {
  color: var(--accent);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.9rem;
}
.section-marker p {
  color: rgba(18, 38, 32, 0.55);
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  margin: 0;
  text-transform: uppercase;
}
.company-story h2,
.section-intro h2,
.values-title h2,
.contact-grid h2 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 1.15;
  margin: 0;
}
.company-story p,
.section-intro > div:last-child > p {
  color: rgba(18, 38, 32, 0.66);
  font-size: 1rem;
  line-height: 1.9;
  margin: 1.25rem 0 0;
}
.stats-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 4rem;
  padding-left: 0;
  padding-right: 0;
}
.stat-item {
  border-right: 1px solid var(--line);
  border-top: 1px solid var(--line);
  min-height: 160px;
  padding: 1.6rem 1.25rem;
}
.stat-item:nth-child(2n) { border-right: 0; }
.stat-item strong {
  color: var(--ink);
  display: block;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2rem;
  font-weight: 400;
}
.stat-item span {
  color: rgba(18, 38, 32, 0.56);
  display: block;
  font-size: 0.82rem;
  line-height: 1.55;
  margin-top: 0.75rem;
}
.solutions-section {
  background: var(--ink);
  color: #f7f3e8;
  padding: 5rem 0;
}
.section-marker.light span { color: #e9a65e; }
.section-marker.light p { color: rgba(247, 243, 232, 0.48); }
.section-intro h2 { color: #f7f3e8; }
.section-intro > div:last-child > p {
  color: rgba(247, 243, 232, 0.6);
  max-width: 45rem;
}
.product-grid {
  border-top: 1px solid rgba(247, 243, 232, 0.18);
  display: grid;
  margin-top: 3.5rem;
}
.product-item {
  border-bottom: 1px solid rgba(247, 243, 232, 0.18);
  min-height: 280px;
  padding: 1.75rem 0;
}
.product-number,
.value-index {
  color: #e9a65e;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.82rem;
}
.product-item h3,
.value-item h3 {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.3;
  margin: 3.5rem 0 0;
}
.product-item h3 { color: #f7f3e8; }
.product-item p,
.value-item p {
  color: rgba(247, 243, 232, 0.58);
  font-size: 0.9rem;
  line-height: 1.75;
  margin: 1rem 0 0;
}
.product-item a {
  align-items: center;
  color: #f7f3e8;
  display: inline-flex;
  font-size: 0.82rem;
  gap: 0.75rem;
  margin-top: 1.75rem;
  text-decoration: none;
}
.values-section { padding: 5rem 0; }
.values-title h2 { margin-top: 2rem; max-width: 19rem; }
.values-list { border-top: 1px solid var(--line); }
.value-item {
  display: grid;
  gap: 0.6rem;
  grid-template-columns: 2rem 1fr;
  padding: 1.75rem 0;
  border-bottom: 1px solid var(--line);
}
.value-index { color: var(--accent); grid-row: 1 / 3; }
.value-item h3 { color: var(--ink); margin: 0; }
.value-item p { color: rgba(18, 38, 32, 0.62); margin: 0.55rem 0 0; }
.contact-section { background: #d8d1c1; padding: 4rem 0; }
.contact-kicker { margin-bottom: 1rem; }
.contact-grid h2 { font-size: 2.65rem; }
.contact-details { border-top: 1px solid rgba(18, 38, 32, 0.28); }
.contact-details p,
.contact-details a {
  border-bottom: 1px solid rgba(18, 38, 32, 0.2);
  color: rgba(18, 38, 32, 0.74);
  display: block;
  font-size: 0.9rem;
  line-height: 1.7;
  margin: 0;
  padding: 1rem 0;
  text-align: left;
  text-decoration: none;
}
@media (min-width: 1024px) {
  .hero {
    min-height: 680px;
  }
  .hero-image-wrap {
    height: 100%;
    left: 44%;
    position: absolute;
    right: 0;
    top: 0;
  }
  .hero-image-wrap::after {
    background: linear-gradient(90deg, #e9e5da 0%, rgba(233, 229, 218, 0.86) 10%, transparent 45%);
  }
  .hero-copy {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 680px;
    padding: 0;
  }
  h1 { font-size: 4.25rem; max-width: 640px; }
  .company-section { padding-top: 7rem; }
  .company-grid { grid-template-columns: 0.75fr 1.65fr; }
  .company-story h2,
  .section-intro h2,
  .values-title h2 { font-size: 3.1rem; }
  .stats-row { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .stat-item { border-right: 1px solid var(--line); padding: 2.2rem 2rem; }
  .stat-item:nth-child(2n) { border-right: 1px solid var(--line); }
  .stat-item:last-child { border-right: 0; }
  .stat-item strong { font-size: 2.7rem; }
  .solutions-section { padding: 7rem 0; }
  .section-intro { grid-template-columns: 0.75fr 1.65fr; }
  .product-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .product-item {
    border-bottom: 0;
    border-right: 1px solid rgba(247, 243, 232, 0.18);
    min-height: 330px;
    padding: 2rem 2.5rem;
  }
  .product-item:first-child { padding-left: 0; }
  .product-item:last-child { border-right: 0; padding-right: 0; }
  .values-section { padding: 7rem 0; }
  .values-layout { grid-template-columns: 0.8fr 1.2fr; gap: 5rem; }
  .contact-section { padding: 5.5rem 0; }
  .contact-grid { grid-template-columns: 0.8fr 1.2fr; gap: 5rem; }
  .contact-grid h2 { font-size: 3.25rem; }
}
@media (max-width: 560px) {
  .hero { min-height: 610px; }
  h1 { font-size: 2.35rem; }
  .stats-row { grid-template-columns: 1fr; }
  .stat-item { border-right: 0; min-height: 130px; }
  .product-item { min-height: 250px; }
  .company-story h2,
  .section-intro h2,
  .values-title h2 { font-size: 1.95rem; }
  .contact-grid h2 { font-size: 2.25rem; }
  .contact-details p,
  .contact-details a { overflow-wrap: anywhere; }
}
@media (prefers-reduced-motion: no-preference) {
  .product-item a span,
  .hero-link span { transition: transform 0.2s ease; }
  .product-item a:hover span { transform: translateX(5px); }
  .hero-link:hover span { transform: translateY(4px); }
}
@media (prefers-reduced-motion: reduce) {
  * { scroll-behavior: auto !important; }
}
</style>
